import { text as moduleText } from './text';

export const text = {
  clearingAndSeedingPlants: moduleText.clearReseeding,
  creatingTemplateGarden: moduleText.creatingGarden,
  creatingPreviewGarden: moduleText.creatingPreviewGarden,

  clearAndSeedSuccess(speciesCount: number, varietyCount: number): string {
    return `Seeded ${speciesCount} species and ${varietyCount} varieties.`;
  },

  seedGardenSuccess(gardenName: string): string {
    return `Successfully created "${gardenName}" garden!`;
  },

  previewGardenSuccess(gardenName: string, plantCount: number, missingPlantCount: number): string {
    const missingSuffix =
      missingPlantCount > 0 ? ` (${missingPlantCount} default plants missing from DB)` : '';
    return `Created "${gardenName}" with ${plantCount} plants${missingSuffix}!`;
  },

  errorMessage(error: unknown): string {
    const message = error instanceof Error ? error.message : String(error);
    return `Error: ${message}`;
  },
};
